import { Component, ElementRef, Input, Output,EventEmitter,OnInit, ViewChild,AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators,NgForm } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { Usuario,DireccionArea,DireccionGral } from 'src/app/interfaces/interfaces';
import { DataService } from 'src/app/services/data.service';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections' ;
import { Paginado } from '../../../models/paginado';
import {Router} from '@angular/router';


@Component({
  selector: 'app-control-usuarios',
  templateUrl: './control-usuarios.component.html',
  styleUrls: ['./control-usuarios.component.scss']
})


export class ControlUsuariosComponent implements OnInit
{
  @Input() emailUsuario: string;
  @Input() modoLider: boolean;
  @Output() formuluarioEditar: EventEmitter<Usuario>;
  @Output() recargartabla: EventEmitter<number>;
  @Output() botonSiguiente = new EventEmitter<boolean>();
  @ViewChild('contenedorRoles',{static:false}) checks: ElementRef;
  usuarios:any;
  loadingGeneral: boolean = true;
  loadingEstatus: boolean = false;
  mostrarFormularioEditar: boolean = false;
  mostrarFormAgregar:boolean=false;
  mostrarlista:boolean=true;
  opcionAdministracion: number = 1;
  indexCambioEstatus: number = -1;
  listaUsuarios: Usuario[] = [];
  formUsuarios: FormGroup;
  formUsuariosAgregar: FormGroup;
  formUsuariosEditar: FormGroup;
  formBuscarUsuario: FormGroup;
  rolesUsuario: { id_rol: number; nombre_rol: string; }[];
  rolesSeleccionados: string[] = [];
  //Lista de jefaturas 
  listaJefaturas:{id_jefatura:number; nombre_jefatura:string}[]=[];
  //Lista subsecretarias
  listaSubsecretarias:{id_subsecretariaSap:number; nombre_subsecretariaSap:string, estatus_subsecretariaSap:boolean}[]=[];

  botonPresionado :number;
  //Variable para mostrar o no el combo de jefatura
  mostrarJefatura : boolean=false;
  mostrarSubsecretaria:boolean=false;
  //Paginación
  paginaActual: Paginado;
  //Total de usuarios
  totalUsuarios:number;
  dependencia:string;
  direccion:string;
  nombre:string;
  email:string;
  //Variables para consulta
  cuenta:string;
  nombreUsuario:string;
  puesto:string;
  direccionGral:string;
  direccionArea:string;
  jefatura:string;
  idDirGral:number;
  nombreSubsecretaria:string;
  

  //Variables para la tabla con filtro
  displayedColumns: string[] = ['Seleccion','Usuario', 'Dependencia', 'Dirección de área', 'Estado', 'VIP',"Acciones"];
  dataSource:any;
  //seleccion: any;
  seleccion= new SelectionModel<Usuario> (true , []);
  direccionesGral: DireccionGral[];
  direccionesArea: DireccionArea[];
  valorFiltro:string;
  
  //dataSource= new MatTableDataSource(this.listaUsuarios);

  get fc() { // acceso a los controles de la form para insertar usuarios
    return this.formUsuarios.controls;
  }

  get f() { // acceso a la form para insertar usuarios
    return this.formUsuarios;
  }


  get fce() { // acceso a los controles de las form para editar usuarios
    return this.formUsuariosEditar.controls;
  }

  get fe() { // acceso a la form para editar usuarios
    return this.formUsuariosEditar;
  }

  get fuc() {
    return this.formBuscarUsuario.controls;
  }

  constructor(
    private dataService: DataService,
    private notifier: NotifierService,
    private router:Router) {
  }

  ngOnInit() {
    this.formBuscarUsuario = new FormGroup({
      idUsuario: new FormControl('', [Validators.required])
    });

    this.formUsuariosEditar = new FormGroup({
      nombre_usuario: new FormControl({value:'', disabled:false}, [Validators.required]),
      email_usuario: new FormControl(''),
      estatus_usuario: new FormControl(1, [Validators.required]),
      dep_usuario: new FormControl({value:'', disabled:false}, [Validators.required]),
      vip_usuario: new FormControl(0, [Validators.required]),
      puesto_usuario: new FormControl({value:'', disabled:false}, [Validators.required]),
      telefono_usuario: new FormControl(''),
      extension_usuario: new FormControl(''),
      id_jefatura: new FormControl(''),
      id_subsecretariaSap: new FormControl(''),
      id_dirGralSap: new FormControl('',[Validators.required]),
      id_areaSap:new FormControl('',[Validators.required]),
      Roles: new FormControl('',[Validators.required]),
      email_usuarioLogin: new FormControl(this.emailUsuario, [Validators.required, Validators.email]),
      nombre_subsecretariaSap: new FormControl(''),
      nuevoEmailUsuario:new FormControl('')
      
    });


    this.paginaActual = new Paginado();
    this.paginaActual.numeroPagina = 1;
    this.cargarUsuarios();
    this.obtenerSubsecretarias();
    
    //Obtener las direcciones generales
    this.dataService.obtenerDireccionGral(0,this.emailUsuario).subscribe(data => {
      this.direccionesGral = data['data'];
    });
  }
 
  cancelar()
  {
    this.mostrarFormularioEditar=false;
    this.mostrarJefatura=false;
    this.mostrarlista=true;
    this.formUsuariosEditar.reset();
    this.listaJefaturas=[];
    //this.formUsuarios.reset();
    while(this.rolesSeleccionados.length) {
      this.rolesSeleccionados.pop();
  }
    this.paginaActual.numeroPagina = 1;
    this.buscarUsuarios(1,'');
  }

  funcionCancelar(e)
  {
    this.botonSiguiente.emit(true);

    this.mostrarFormAgregar=false;
    this.mostrarFormularioEditar=false;
    this.paginaActual.numeroPagina = 1;
    this.buscarUsuarios(1,'');
    this.mostrarlista=true;
  }

  onSubmitReactive(btnId:number, cuenta?:string)
  {
    this.botonPresionado=btnId;
    if(this.botonPresionado==1)
    {
      this.activarBloquear();
    }
    if(this.botonPresionado==2)
    {
      this.cambiarEstatusVIP();
    }
    //Boton de agregar
    if(this.botonPresionado==3)
    {
      this.mostrarFormAgregar=true;
      this.mostrarlista=false;
      //this.router.navigate(['./add-usuario'])
    }

    if(this.botonPresionado==4)
    {
      this.mostrarlista=false;
      this.mostrarFormAgregar=false;
      this.dataService.obtenerTiposUsuariosv2().subscribe(
        data => {
          this.rolesUsuario = data['data'];
          this.mostrarFormularioEditar=true;
          this.cargarInfoUsuarios(cuenta,data['data']);
        },
        error => {
          console.error(error);       
        }
      );

    }

  }

  /*obtenerJefaturas(user:Usuario)
  {
    this.dataService.obtenerJefaturas(user).subscribe(
      data => {
        this.listaJefaturas = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }*/

  //Método para obtener la subsecretaria segun la dir gral.
  subsecretariaByDirGral(idGral:number)
  {
    this.dataService.getSubsecretariaByIdGeneral(idGral).subscribe(
      data => {
        this.listaSubsecretarias = data['data'];
        this.nombreSubsecretaria=data['objData']['nombre_subsecretariaSap'];
         //Formulario editar
          this.formUsuariosEditar.patchValue({
            id_subsecretariaSap:data['objData']['id_subsecretariaSap']
          });
      },
      error => {
        console.error(error);       
      }
    );
  }


  //Método para obtener las subsecretarias 
  obtenerSubsecretarias()
  {
    this.dataService.getListSubsecretarias().subscribe(
      data => {
        this.listaSubsecretarias = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }



  agregarQuitarRol(rol: string) 
  {
    let index = this.rolesSeleccionados.indexOf(rol);
    if (index !== -1) 
    {
      this.rolesSeleccionados = this.rolesSeleccionados.filter(el => el !== rol);
    } else {
      this.rolesSeleccionados.push(rol);
    }

    if (this.mostrarFormularioEditar) 
    {
        this.formUsuariosEditar.patchValue({
        Roles: this.rolesSeleccionados.toString()     
      });
    }

    let subse=this.formUsuariosEditar.controls['Roles'].value;
    let posicion=subse.indexOf("11");
    //Verificamos si el rol es de tipo subsecretario
    if(posicion!== -1)
    {

      this.mostrarSubsecretaria=true;
      this.subsecretariaByDirGral(this.idDirGral);
    }
    else{
      this.mostrarSubsecretaria=false;
      this.formUsuariosEditar.patchValue({
        id_subsecretariaSap:0
      });
      //this.formUsuariosEditar.controls['id_subsecretaria'].reset();
    }  
    
  }

 cargarUsuarios() 
  {
    this.loadingGeneral = true;
    this.dataService.cargarUsuariosAutorizados(this.paginaActual.numeroPagina,"").subscribe(res => {
      if (res['alert']==1) 
      {
        this.notifier.notify('error', 'No se han podido cargar los usuarios. Revisa tu conexión de red e inténtalo nuevamente más tarde.')
      }else{
        this.totalUsuarios=res['total_registros'];
        this.listaUsuarios = res['data'];
        this.dataSource = new MatTableDataSource(this.listaUsuarios);
      }
      //this.seleccion= new SelectionModel<Usuario> (true , []);
      this.loadingGeneral = false;
    });
  }

 

 ngAfterViewInit()
  {
      //console.log("vista afterview", this.checks);
  }

  cargarInfoUsuarios(cuenta: string, listaRoles:any) 
  {
    
    if (cuenta !== '') 
    {
      this.dataService.obtenerInfoUsuario(cuenta).subscribe(res => {
        if (res['errorMessage']) {        
          this.notifier.notify('error', 'Ha ocurrido un error al intentar obtener la información del usuario. Revisa tu conexión de red e inténtalo nuevamente más tarde.');
        } else {
          let infoUser: Usuario = res['objData'];
          this.cuenta=infoUser.email_usuario;
          this.nombreUsuario=infoUser.nombre_usuario;
          this.puesto=infoUser.puesto_usuario;
          this.dependencia=infoUser.dep_usuario;
          this.direccionGral=infoUser.nombre_dirgralSap;
          this.direccionArea=infoUser.nombre_areaSap;
          this.jefatura=infoUser.nombre_jefatura;
          this.idDirGral=infoUser.id_dirgralSap;

          this.formUsuariosEditar.patchValue({
            nombre_usuario: infoUser.nombre_usuario,
            email_usuario:infoUser.email_usuario,
            estatus_usuario: infoUser.estatus_usuario,
            dep_usuario: infoUser.dep_usuario,
            vip_usuario: infoUser.vip_usuario,
            puesto_usuario: infoUser.puesto_usuario,
            id_jefatura: infoUser.id_jefatura,
            id_subsecretariaSap:infoUser.id_subsecretariaSap,
            id_dirGralSap: infoUser.id_dirgralSap,
            id_areaSap:infoUser.id_areaSap,
            Roles: infoUser.roles,
            nombre_subsecretariaSap:infoUser.nombre_subsecretariaSap,
            email_usuarioLogin:this.emailUsuario

          });
          //Id's produccion gral:331, areaSap:3001,3005,3002
          //Id's QA gral: 231, areaSAP: 1753, 1754, 1755
          if(res['objData']['id_dirgralSap']==331 && (infoUser.id_areaSap==3001 || infoUser.id_areaSap==3005 || infoUser.id_areaSap==3002))
          {
            this.mostrarJefatura=true;  
            //Cargamos las jefaturas 
            this.dataService.obtenerJefaturas(infoUser.id_areaSap).subscribe(
              data => {
                if (data['data']) {
                  this.listaJefaturas = data['data'];
                }
              },
              error => {
                console.log(error);
              }
            );

          }
         /* if(res['objData']['nombre_dirgralSap'].toUpperCase()=="DIRECCION GENERAL DE TECNOLOGIAS DE LA INFORMACION Y TELECOMUNICACIONES" ||
              res['objData']['nombre_dirgralSap'].toUpperCase()=="DIR. GRAL. DE TEC. DE INFORM. Y TELECOM.")
              {
                this.mostrarJefatura=true;               
              }*/
          if(res['objData']['id_subsecretariaSap'])
          {
            //this.obtenerSubsecretarias();
            this.mostrarSubsecretaria=true;
          }
          else{
            this.mostrarSubsecretaria=false;
          }
          this.mostrarFormularioEditar = true;
          let usr = Array.from(this.checks.nativeElement.children);
            usr.forEach((rol: any) => {
            if (rol.children[0].checked) 
            {
               rol.children[0].click();
            }
          }); 
           usr.forEach((rol: any) => {
            if (infoUser.roles.split(',').findIndex(x => x === rol.children[0].id) !== -1) {
                  rol.children[0].click();
            }
          });
        }
      });
    } else {
      this.notifier.notify('error', 'Ha ocurrido un error al intentar cargar la información del usuario.');
      this.mostrarFormularioEditar = false;
      this.mostrarlista=true;
      //this.paginaActual.pageNumber = 1;
      this.buscarUsuarios(this.paginaActual.numeroPagina,'');
    }
  }

  editarUsuario() 
  {
    if(this.mostrarSubsecretaria==false)
    {
      this.formUsuariosEditar.controls['id_subsecretariaSap'].reset();
    }
    this.dataService.editarUsuario(this.formUsuariosEditar.value).subscribe(res => {
      if (res['errorMessage']) 
      {
        this.notifier.notify('error','Ha ocurrido un error al intentar editar el usuario. Revisa tu conexión de red en inténtalo de nuevo más tarde.');
      } else {
        this.formUsuariosEditar.reset({ opcion: 2, vip: 0, estatus: 1 });
        this.mostrarFormularioEditar = false;
        this.mostrarJefatura=false;
        this.notifier.notify('success', 'Usuario editado correctamente.');
        this.mostrarlista=true;
        while(this.rolesSeleccionados.length) {
          this.rolesSeleccionados.pop();
        }
        while(this.listaJefaturas.length) {
          this.listaJefaturas.pop();
        }
        if(this.listaSubsecretarias){
          while(this.listaSubsecretarias.length) {
            this.listaSubsecretarias.pop();
          }
        }
        
        this.paginaActual.numeroPagina = 1;
        this.buscarUsuarios(1,'');
      }
    });
  }



  scrollInicio() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // pasos cada intervalo
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  cambioTab(opcion: number) {
    this.opcionAdministracion = opcion;
    this.formUsuarios.reset({ opcion: 1, vip: 0, estatus: 1 });
    this.formUsuariosEditar.reset({ opcion: 2, vip: 0, estatus: 1 });
    this.mostrarFormularioEditar = false;
    if (opcion !== 1) {
      this.cargarUsuarios();
      //this.cargarSiguientes();
    }
  }

/* Angular Material*/
//Método que retorna el número de columnas que estan seleccionadas
  isAllSelected () 
  {
    const numSelected = this.seleccion.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle () {
    this.isAllSelected ()?
    this.seleccion.clear ():
    this.dataSource.data.forEach ( row =>this.seleccion.select (row));
  }


  checkboxLabel (row ?:Usuario):string 
  {
    if (!row ) {
      return  ` $ {this.isAllSelected ()? 'select': 'deselect'} all` ;
   }
   return  `${this.seleccion.isSelected (row)? 'deseleccionar': 'seleccionar'} fila $ {row.position + 1}` ;
 }


//Método para aplicar el filtro 
  applyFilter(event: Event) 
  {
    const filterValue = (event.target as HTMLInputElement).value;
    this.paginaActual.numeroPagina=1;
    this.buscarUsuarios(this.paginaActual.numeroPagina, filterValue.trim().toLocaleLowerCase());
    //this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  buscarUsuarios(pagina:number, valor:string)
  {
    this.valorFiltro=valor;
    this.loadingGeneral = true;
    this.dataService.cargarUsuariosFiltro(pagina,this.formUsuariosEditar.value,valor).subscribe(res => {
      if (res['errorMessage']) 
      {
      } else 
      {
        this.loadingGeneral = false;
        this.totalUsuarios=res['total_registros'];
        this.listaUsuarios= res['data'];
        this.dataSource = new MatTableDataSource(this.listaUsuarios);       
    }});
  }


  //Método para activar/bloquear los usuarios selecionados
  activarBloquear()
  {
    let valores = this.seleccion.selected;
    
     if(valores.length > 0 )
     {
    this.dataService.cambioEstatus(this.seleccion.selected).subscribe(res => {
      if (res['errorMessage']) {
        this.notifier.notify('error',
        'Ha ocurrido un error al intentar cambiar el estatus del usuario(s). Revisa tu conexión de red en inténtalo de nuevo más tarde.');
      } else {
        this.notifier.notify('success', 'Usuario(s) editado(s) correctamente.');
        this.seleccion.clear();
        this.paginaActual.numeroPagina=1;
        this.buscarUsuarios(1,'');
        //this.cargarUsuarios();
      }
    });
  }
  else{
    this.notifier.notify('error', 'Seleccione un usuario.');
    this.paginaActual.numeroPagina=1;
    //this.cargarUsuarios();
    this.buscarUsuarios(1,'');
  }
}


  //Método para activar/bloquear los usuarios selecionados
  cambiarEstatusVIP()
  {
    let valores = this.seleccion.selected;
    if(valores.length > 0 )
    {
    this.dataService.cambiarEstatusVIP(this.seleccion.selected).subscribe(res => {
      if (res['errorMessage']) 
      {
        this.notifier.notify('error',
        'Ha ocurrido un error al intentar cambiar el estatus del usuario(s). Revisa tu conexión de red en inténtalo de nuevo más tarde.');
      } else {
        this.notifier.notify('success', 'Usuario(s) editado(s) correctamente.');
        this.seleccion.clear();
        this.paginaActual.numeroPagina=1;
        this.buscarUsuarios(1,'');
        //this.cargarUsuarios();
      }
    });
  }
  else{
    this.notifier.notify('error', 'Seleccione un usuario.');
    this.paginaActual.numeroPagina=1;
    this.buscarUsuarios(1,'');
    //this.cargarUsuarios();
  }
   
  }

  //Método de paginación
  cargarSiguientes() 
  {
    this.loadingGeneral = true;
    this.seleccion.clear();
    this.paginaActual.numeroPagina++;
    this.paginaActual.email = this.emailUsuario;
      this.dataService.cargarUsuariosFiltro(this.paginaActual.numeroPagina++, this.formUsuariosEditar.value, this.valorFiltro).subscribe(res => {
        if (res['alert']==1) 
        {
          this.notifier.notify('error', 'No se han podido cargar los usuarios. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
        } else {
         
          this.listaUsuarios= res['data'];
            this.dataSource = new MatTableDataSource(this.listaUsuarios);
            this.paginaActual.numeroPagina--;
        }
        this.loadingGeneral = false;
      });
  }


   //Método de paginación
   cargarAnteriores() 
   {
     this.loadingGeneral = true;
     this.seleccion.clear();
     //this.paginaActual.pageNumber--;
     this.paginaActual.email = this.emailUsuario;
    
       this.dataService.cargarUsuariosFiltro(this.paginaActual.numeroPagina-1,this.formUsuariosEditar.value,this.valorFiltro).subscribe(res => {
         if (res['alert']==1) 
         {
           this.notifier.notify('error', 'No se han podido cargar los usuarios. Revisa tu conexión de red e inténtalo de nuevo más tarde.');
         } else {
           this.listaUsuarios= res['data'];
             this.dataSource = new MatTableDataSource(this.listaUsuarios);
             this.paginaActual.numeroPagina--;
         }
         this.loadingGeneral = false;
       });
   }

}
